/* Soft organic scroll motion for the Eco theme.
 * - Reveals top-level sections as they enter the viewport.
 * - Staggers any element tagged with .eco-stagger.
 * - Adds a whisper of parallax to [data-eco-parallax] elements.
 * Progressive enhancement: if anything is unsupported, content
 * simply stays visible. Respects prefers-reduced-motion.
 */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = document.documentElement.classList.contains('shopify-design-mode');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---- Paper-crinkle intro (once per browser session) ---- */
  function playPaperIntro() {
    if (reduceMotion || inEditor) return;
    var KEY = 'ecoPaperIntroSeen';
    try {
      if (window.sessionStorage && sessionStorage.getItem(KEY)) return;
      if (window.sessionStorage) sessionStorage.setItem(KEY, '1');
    } catch (e) {}
    var overlay = document.createElement('div');
    overlay.id = 'eco-paper-intro';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);
    var done = function () {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    };
    overlay.addEventListener('animationend', done);
    setTimeout(done, 3200); // safety net (must exceed intro duration)
  }
  playPaperIntro();

  ready(function () {
    if (reduceMotion || inEditor || !('IntersectionObserver' in window)) return;

    /* ---- Reveal on scroll ---- */
    var revealTargets = [];

    // Auto-reveal each top-level section (skip the header/announcements).
    document
      .querySelectorAll('#MainContent > .shopify-section, #MainContent .shopify-section')
      .forEach(function (el) {
        if (el.closest('#header-group')) return;
        if (!el.classList.contains('eco-stagger')) el.classList.add('eco-reveal');
        revealTargets.push(el);
      });

    // Explicit opt-ins authored in sections.
    document.querySelectorAll('.eco-reveal, .eco-stagger').forEach(function (el) {
      if (revealTargets.indexOf(el) === -1) revealTargets.push(el);
    });

    var revealObserver = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('eco-in');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    revealTargets.forEach(function (el) {
      // If it is already in view on load, reveal immediately (no flash).
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92) {
        el.classList.add('eco-in');
      } else {
        revealObserver.observe(el);
      }
    });

    /* ---- Homepage: opt media images into gentle scroll parallax ---- */
    var main = document.getElementById('MainContent');
    var template = main ? main.getAttribute('data-template') || '' : '';
    if (template.indexOf('index') === 0) {
      main
        .querySelectorAll('.media img, .banner__media img, .group-block-media img')
        .forEach(function (img) {
          if (img.closest('.product-card')) return; // keep product cards crisp
          if (img.hasAttribute('data-eco-parallax')) return;
          img.setAttribute('data-eco-parallax', '0.045');
          img.setAttribute('data-eco-parallax-scale', '1.12');
        });
    }

    /* ---- Gentle parallax (transform-only, GPU friendly) ---- */
    var parallaxEls = Array.prototype.slice.call(
      document.querySelectorAll('[data-eco-parallax]')
    );
    if (parallaxEls.length) {
      var ticking = false;
      var update = function () {
        var vh = window.innerHeight;
        for (var i = 0; i < parallaxEls.length; i++) {
          var el = parallaxEls[i];
          var rect = el.getBoundingClientRect();
          // Skip work for anything well outside the viewport.
          if (rect.bottom < -200 || rect.top > vh + 200) continue;
          var speed = parseFloat(el.getAttribute('data-eco-parallax')) || 0.1;
          var scale = el.getAttribute('data-eco-parallax-scale');
          var offset = (rect.top + rect.height / 2 - vh / 2) * -speed;
          el.style.transform =
            'translate3d(0,' + offset.toFixed(1) + 'px,0)' +
            (scale ? ' scale(' + scale + ')' : '');
        }
        ticking = false;
      };
      var onScroll = function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }
  });
})();
